export default __webpack_public_path__ + "static/media/Michela Giuffrida.6ba5d491.jpg";